import React from 'react'
import FlexView from 'react-flexview/lib'
import { isMobile } from 'react-device-detect'
import { NUMBER_OF_DRONES_QUESTION_ANSWERS } from "../../../../Constants";

var classNames = require('classnames')

interface NumberOfDronesProps {
    numberOfDronesOperate: number
}

export const NumberOfDrones = ({numberOfDronesOperate}: NumberOfDronesProps) => {

    //{NUMBER_OF_DRONES_QUESTION_ANSWERS[option]["title"]}  ({NUMBER_OF_DRONES_QUESTION_ANSWERS[option]["value"]}
    return (<>
            <FlexView marginTop={15} className="space-between margin-bottom-basic space-between margin-bottom-basic">
                <div className="text-body bold black">Number of operating drones</div>
            </FlexView>
            <FlexView column={true} className={classNames({"space-between": !isMobile})}>
                <div className="black text-small">
                    {NUMBER_OF_DRONES_QUESTION_ANSWERS[numberOfDronesOperate]["title"]}
                </div>
                <div>
                    {numberOfDronesOperate !== 2 &&
                    <span className="gray margin-top-small text-tiny">
                        {NUMBER_OF_DRONES_QUESTION_ANSWERS[numberOfDronesOperate]["value"]}
                    </span> 
                    }
                </div>

            </FlexView>
        </>
    )
}